import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { SubscribeToTextNotifications } from 'src/app/core/models/subscribeToTextNotifications';
import { NotificationService } from 'src/app/notification/notification.service';
import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';
import { AlertService } from 'src/app/shared/toast/alert.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
title:any="Settings"
SubscribeToTextNotifications:SubscribeToTextNotifications=new SubscribeToTextNotifications();
constructor(private loaderService: CustomLoadingService, private notificationService: NotificationService,private toastService: AlertService) {
  
}

  ngOnInit(): void {
    this.getSubscribeToTextNotifications();
  }

  getSubscribeToTextNotifications() {
    this.notificationService.GetSubscribeToTextNotifications().subscribe(res => {
     this.SubscribeToTextNotifications=res;
    }, (error) => {


    }, () => {

    })

  }

  setSubscribeToTextNotifications(isSubscribeToTextNotifications:any) {
    
    this.notificationService.setSubscribeToTextNotifications(isSubscribeToTextNotifications).subscribe(res => {
      this.getSubscribeToTextNotifications();
    this.toastService.success(res.Message);
    }, (error) => {


    }, () => {

    })

  }

}
